import React from 'react';
import { OpenSidebarPayload, useFeatureToggle, useSidebar } from '@css-xp/base';
import Button from '@atlaskit/button/standard-button';
import { ApolloQueryResult } from '@apollo/client';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { getChangeBillDateSidebarPayload } from '@css-xp/entitlements-v2';

interface ChangeBillDateButtonProps {
  entitlement: EntitlementDetails;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
}

export const ChangeBillDateButton = ({ entitlement, refetch }: ChangeBillDateButtonProps) => {
  const { openSidebar } = useSidebar();
  const [isEnabled] = useFeatureToggle();
  // FIXME :: Move the flags outside or remove them during FF cleanup
  const isAddOnChangesEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_ADD_ONS);
  const isSandboxSupportForSubscriptionsEnabled = isEnabled(
    STATSIG_FEATURE_GATES.ENABLE_SANDBOX_SUPPORT_FOR_SUBSCRIPTIONS
  );
  const isSandboxDecouplingEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_SANDBOX_DECOUPLING);

  const handleSidebarAction = (openSidebarPayload: OpenSidebarPayload) => {
    openSidebar(openSidebarPayload);
  };
  const changeBillDatePayload = getChangeBillDateSidebarPayload(
    entitlement,
    refetch,
    isAddOnChangesEnabled,
    isSandboxSupportForSubscriptionsEnabled,
    isSandboxDecouplingEnabled
  );

  return (
    <Button
      aria-label="Change Bill Date"
      appearance="link"
      className="inner-text"
      onClick={() =>
        handleSidebarAction({
          ...changeBillDatePayload,
          sidebarType: changeBillDatePayload.sidebar,
          sidebarOptions: {
            isOverlay: true,
            sidebarWidth: '600px',
          },
        })
      }
      isDisabled={!!entitlement?.upgradeTrial}
      testId="change-bill-date-btn"
    >
      Change
    </Button>
  );
};
